import { type TDeviceType } from '@cian/ui-kit';

import { toCssImageUrl } from 'shared/utils/toCssImageUrl';
import { type TParallaxGeneralContext } from 'shared/types/bannerContext';

/** Выбирает URL картинки по типу устройства с фолбэком на альтернативный источник. */
export const pickImageUrl = (
  deviceType: TDeviceType,
  desktopUrl: string | undefined,
  mobileUrl: string | undefined,
): string => (deviceType === 'desktop' ? desktopUrl || mobileUrl : mobileUrl || desktopUrl) ?? '';

export const getTextImageUrl = (context: TParallaxGeneralContext, deviceType: TDeviceType): string =>
  toCssImageUrl(pickImageUrl(deviceType, context.textImageUrl, context.mobTextImageUrl));
